/* eslint-disable */
import httpParam from '@ve/services/httpParam';

export default (hotelId: number, identities: string[]) => document.location.href = `/hotel/${hotelId}/railwaysTourPage?${httpParam({ identities })}`;